import { useQuery } from "@tanstack/react-query";
import { rmOlkApi } from "components/api/comm";
import Select, { SelectProps } from "components/select";
import { IRmComm, ISelect } from "interface";
import { useRef } from "react";
import useAuthStore from "store/auth";

interface IProps extends Omit<SelectProps, "options"> {
  isReset?: boolean;
  select?(inf: any): void;
}
export default function RmOlkCdSlect({
  defaultValue,
  dataTyp,
  isUpdateAble,
  isReset,
  select,
}: IProps) {
  const isLogin = useAuthStore((state) => state.isLogin);
  const rmOlkRef = useRef<ISelect[]>([]);
  useQuery({
    queryKey: ["rmOlkList"],
    queryFn: () => {
      return rmOlkApi();
    },
    enabled: isLogin,
    select: (data) => {
      if (data) {
        rmOlkRef.current = data.data?.cdList.map((typ: IRmComm) => {
          return {
            ko: typ.langCd === "ko" ? typ.codNm : "",
            en: typ.langCd === "en" ? typ.codNm : "",
            value: typ.lodCd,
            code: typ.lodCd,
          };
        });
      }
    },
  });
  return (
    <>
      <Select
        options={rmOlkRef.current}
        styles="bg-white border-1"
        name={"rmOlkCd"}
        dataTyp={dataTyp}
        validateTxt="객실전망을 선택하여 주세요."
        defaultValue={defaultValue}
        isUpdateAble={isUpdateAble}
        isReset={isReset}
        onSelect={(option) => {
          select && select(option?.code);
        }}
      />
    </>
  );
}
